import React from "react";

export default function HeroSection() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-copy">
        <p className="eyebrow">Reiki & holistic well-being · Burlington, ON</p>
        <h1 id="hero-title">A little stillness.<br />A deeper sense of <em>balance.</em></h1>
        <p className="hero-description">Make space to slow down, reconnect, and come back to yourself. Personalized Reiki with Ankita, in person or from the comfort of your home.</p>
        <div className="hero-actions">
          <a className="button-primary" href="#pricing">Explore sessions <span aria-hidden="true">↗</span></a>
          <a className="text-link" href="#about">Meet Ankita <span aria-hidden="true">→</span></a>
        </div>
        <p className="hero-note">Certified Usui Holy Fire Reiki III Practitioner</p>
      </div>
      <div className="hero-visual">
        <img src="./lotus_beautiful.jpg" alt="A lotus flower in bloom on peaceful water" fetchpriority="high" />
        <div className="hero-caption"><span>YOUR MOMENT TO EXHALE</span><p>Rooted in care.<br /> Centered on you.</p></div>
      </div>
    </section>
  );
}
